import React from 'react';
import PropTypes from 'prop-types';
import { Panel, Glyphicon, Collapse, Button } from 'react-bootstrap';

import InstallerTableContainer from './../Containers/InstallerTableContainer';
import InstallerTestExpectedModalContainer
  from './../Containers/InstallerTestExpectedModalContainer';
const InstallerTableWrapperComponent = ({
  expanded,
  panelStyle,
  setExpanded,
  showTestsExpectedModal
}) => (
  <Panel bsStyle={panelStyle}>
    <Panel.Heading>
      <Panel.Title>
        <div style={{ paddingRight: '30px' }}>
          <Glyphicon
            className="pointer"
            glyph={expanded ? 'minus' : 'plus'}
            onClick={() => setExpanded(!expanded)}
          />
          <span> Installer Changes</span>
        </div>
      </Panel.Title>
    </Panel.Heading>
    <Collapse in={expanded}>
      <div>
        <InstallerTestExpectedModalContainer buildPage />
        <Button onClick={() => showTestsExpectedModal(true)}>
          Show Expected Tests
        </Button>
        { expanded && <InstallerTableContainer showExpected={false} /> }
      </div>
    </Collapse>
  </Panel>
);

InstallerTableWrapperComponent.propTypes = {
  expanded: PropTypes.bool,
  panelStyle: PropTypes.string.isRequired,
  setExpanded: PropTypes.func.isRequired,
  showTestsExpectedModal: PropTypes.func.isRequired
};

export default InstallerTableWrapperComponent;


// WEBPACK FOOTER //
// src/Components/InstallerTableWrapperComponent.jsx